import Alert from "@amzn/awsui-components-react/polaris/alert";
import Box from "@amzn/awsui-components-react/polaris/box";
import Button from "@amzn/awsui-components-react/polaris/button";
import { useGetTeamsQuery } from "components/header/endpoints";
import { ITeamsLoadGuardProps } from "./definitions";

function TeamsLoadGuard({ children }: ITeamsLoadGuardProps) {
  // `error` survives a pending refetch, unlike `isError`, so Retry keeps the
  // alert on screen with its loading state until the request settles.
  const { data, error, isFetching, refetch } = useGetTeamsQuery();

  if (!error || data) {
    return <>{children}</>;
  }

  return (
    <Box padding={{ top: "l" }}>
      <Alert
        type="error"
        header="We couldn't load your teams. Please try again."
        action={
          <Button loading={isFetching} onClick={() => refetch()}>
            Retry
          </Button>
        }
      />
    </Box>
  );
}

export default TeamsLoadGuard;
